/** Dvorak (ANSI US): maps a physical code to the character that key emits. */
export const DVORAK_CODE_TO_CHAR: Record<string, string> = {
  Backquote: "`",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  Digit0: "0",
  Minus: "[",
  Equal: "]",
  KeyQ: "'",
  KeyW: ",",
  KeyE: ".",
  KeyR: "P",
  KeyT: "Y",
  KeyY: "F",
  KeyU: "G",
  KeyI: "C",
  KeyO: "R",
  KeyP: "L",
  BracketLeft: "/",
  BracketRight: "=",
  Backslash: "\\",
  KeyA: "A",
  KeyS: "O",
  KeyD: "E",
  KeyF: "U",
  KeyG: "I",
  KeyH: "D",
  KeyJ: "H",
  KeyK: "T",
  KeyL: "N",
  Semicolon: "S",
  Quote: "-",
  KeyZ: ";",
  KeyX: "Q",
  KeyC: "J",
  KeyV: "K",
  KeyB: "X",
  KeyN: "B",
  KeyM: "M",
  Comma: "W",
  Period: "V",
  Slash: "Z",
};
